import axios from 'axios';
import authHeader from './auth-header';

const API_URL = 'https://api.protektor-polska.pl:5000/api/'; //'http://85.255.5.121:5000/api/' //http://localhost:5000/api/ //https://api.protektor-polska.pl:5000/api/

class UserService {
  getAdminBoard() {
    return axios.get(API_URL + 'admin', { headers: authHeader() });
  }

  create(Order) {
    return axios.post(API_URL + 'admin/create', Order, { headers: authHeader() });
  }

  update(Order) {
    return axios.post(API_URL + 'admin/update', Order, { headers: authHeader() });
  }

  delete(Order) {
    return axios.post(API_URL + 'admin/delete', Order, { headers: authHeader() });
  }

  getComments(orderId){
    return axios.post(API_URL + 'admin/getallcomments', orderId, { headers: authHeader()})
  }

  createComment(comment){
    return axios.post(API_URL + 'admin/createcomment', comment, { headers: authHeader()})
  }
}

export default new UserService();